export default "__VITE_ASSET__D02RC2LA__"